import { Component, OnInit, ViewChild, ElementRef, Input, ViewChildren } from '@angular/core';
import { UtilsService } from 'src/app/services/utils.service';
import { Observable, Observer } from 'rxjs';
import { FormControl } from '@angular/forms';
import { map } from 'rxjs/operators';
import { FolkService } from 'src/app/services/school/folk.service';
import { ReligionService } from 'src/app/services/category/religion.service';
import { NationnalityService } from 'src/app/services/category/nationnality.service';
import { ProvinceService } from 'src/app/services/category/province.service';
import { DistrictService } from 'src/app/services/category/district.service';
import { WardService } from 'src/app/services/category/ward.service';
import { Student } from 'src/app/model/school/student.model';
import { StudentService } from 'src/app/services/school/student.service';
import { CertificateTakeCareOfStudent } from 'src/app/model/school/certificate-take-care-of-student.model';
import { StudentLearningProcess } from 'src/app/model/school/student-learning-process.model';
import { TeacherInCharge } from 'src/app/model/school/teacher-in-charge.model';
import { DisbilityOfStudent } from 'src/app/model/school/disbility-of-student.model';
import { PolicyOfStudent } from 'src/app/model/school/policy-of-student.model';
import { SocialCommunicationService } from 'src/app/services/category/social-communication.service';
import { SelfServiceService } from 'src/app/services/category/self-service.service';
import { EffectiveMedicalSupportService } from 'src/app/services/category/effective-medical-support.service';
import { NeedOfDisabilityService } from 'src/app/services/category/need-of-disability.service';
import { InformationOfMedicalService } from 'src/app/services/category/information-of-medical.service';
import { CaregiverService } from 'src/app/services/category/caregiver.service';
import { LivingConditionService } from 'src/app/services/category/living-condition.service';
import { IncomeService } from 'src/app/services/category/income.service';
import { MainOfIncomeService } from 'src/app/services/category/main-of-income.service';
import { SupportCostService } from 'src/app/services/category/support-cost.service';
import { EconomicIndependenceService } from 'src/app/services/category/economic-independence.service';
import { AcademicLevelService } from 'src/app/services/category/academic-level.service';
import { EducationalStatusService } from 'src/app/services/category/educational-status.service';
import { ServiceParticipationService } from 'src/app/services/category/service-participation.service';
import { TypeOfOrganizationService } from 'src/app/services/category/type-of-organization.service';
import { KindOfSupportService } from 'src/app/services/category/kind-of-support.service';
import { CareerService } from 'src/app/services/category/career.service';
import { FamilyConcernLevelService } from 'src/app/services/category/family-concern-level.service';
import { SuggestService } from 'src/app/services/category/suggest.service';
import { StudyModeService } from 'src/app/services/category/study-mode.service';
import { ModesOfEducationService } from 'src/app/services/category/modese-of-education.service';
import { CommonFilter } from 'src/app/model/commonfilter/commonfilter';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { ConfirmComponent } from '@ascschool/project/popups/confirm/confirm.component';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { CategoryModel } from '@ascschool/model/category/category-model.model';
import { Nationality } from '@ascschool/model/category/nationality.model';
import { Religion } from '@ascschool/model/category/religion.model';
import { Folk } from '@ascschool/model/school/folk.model';
import { Ward } from '@ascschool/model/category/ward.model';
import { District } from '@ascschool/model/category/district.model';
import { Province } from '@ascschool/model/category/province.model';
import { ModesOfEducation } from '@ascschool/model/category/modes-of-education.model';
import { HinhThucHoc } from '@ascschool/model/category/hinh-thuc-hoc.model';
import { CertificateTakeCareOfStudentService } from '@ascschool/services/school/certificate-take-care-of-student.service';
import { DisbilityOfStudentService } from '@ascschool/services/school/disbility-of-student.service';
import { PolicyOfStudentService } from '@ascschool/services/school/policy-of-student.service';
import { StudentLearningProcessService } from '@ascschool/services/school/student-learning-process.service';
import { StaffStudentService } from '@ascschool/services/user/staff-student.service';
import { EducationLevelsService } from '@ascschool/services/school/education-levels.service';
import { CaDisCausesService } from '@ascschool/services/school/caDisCauses.service';
import { MaritalStatusService } from '@ascschool/services/school/marital-status.service';
import { EmploymentStatusService } from '@ascschool/services/school/employment-status.service';
import { LevelOfDevelopmentService } from '@ascschool/services/school/level-of-development.service';
import { StudentLevelOfDevelopmentService } from '@ascschool/services/school/student-level-of-development.service';
import { DisStudentLevelOfDevelopment } from '@ascschool/model/school/student-level-of-development';
import { TypeOfDisabilityService } from '@ascschool/services/category/typeofdisability.service';
import { LevelService } from '@ascschool/services/category/level.service';
import { CadisInterventionStatussService } from '@ascschool/services/category/cadis-Intervention-Statuss.service';
import { LevelOfDevelopmentTypesService } from '@ascschool/services/school/level-of-development-types.service';
import { NeedForEducationalSpService } from '@ascschool/services/survey/need-for-educational-sp.service';
import { SurveyPublicService } from '@ascschool/services/public/survey-public.service';
import { NoiSinhService } from '@ascschool/services/category/noi-sinh.service';
import { ThoiDiemKhuyetTatService } from '@ascschool/services/category/thoi-diem-khuyet-tat.service';
import { ChuongTrinhHocService } from '@ascschool/services/category/chuong-trinh-hoc.service';
import { SchoolLevelService } from '@ascschool/services/school/school-level.service';
import { RelationshipService } from '@ascschool/services/new/relationship.service';
import * as _ from 'lodash';
import { TutorCareersService } from '@ascschool/services/category/tutor-career.service';
import { PtHtNktVanDongService } from '@ascschool/services/new/pt-ht-nkt-van-dong.service';

@Component({
  selector: 'app-student-view',
  templateUrl: './student-view.component.html',
  styleUrls: ['./student-view.component.scss']
})
export class StudentViewComponent implements OnInit {
  @ViewChildren("label") labelElement;
  @ViewChild('studentAvatar', { static: true }) studentAvatar: ElementRef;
  @Input() educationAndTrainingOrSchoolId: any;
  @Input() dataTransmission: any;
  isNote : boolean;
  isNoteRelationship : boolean;
  isNoteCaregiver : boolean;
  isNoteFacilities: boolean;
  width: number;
  loading = false;
  avatarUrl?: string;
  heightTab: number;
  StudentCodeControl = new FormControl('');
  StudentNameControl = new FormControl('');
  StudyOfYearControl = new FormControl('');
  DateOfBirthControl = new FormControl('');
  PlaceOfBirthControl = new FormControl('');
  commonFilter = new CommonFilter();
  student = new Student();
  isEditMode: boolean;
  fileHinh: any;
  checkedAll: boolean = false;
  firstRowOnPage: any;
  loadAvataPath: string = '';
  studentId: number;
  maxHeight: number;
  height: any;
  heightPopup: number;
  listChungChiCha: CertificateTakeCareOfStudent[] = [];
  listChungChiMe: CertificateTakeCareOfStudent[] = [];
  listChungChiTutor: CertificateTakeCareOfStudent[] = [];
  listKT: DisbilityOfStudent[] = [];
  listPolicy: PolicyOfStudent[] = [];
  listQTHT: StudentLearningProcess[] = [];
  listGVPT: TeacherInCharge[] = [];
  listMDPT: DisStudentLevelOfDevelopment[] = [];
  yearNow = (new Date()).getFullYear();
  lstLevelOfDeDto: any[] = []; lstLevelOfDeDtoSelected: LevelOdedto[] = [];
  isDisability: boolean;
  ////////////////////////////////////////////////////////////////////////autoComplete////////////////////////////////////////////////////////////////////
  getFolkACFn: (value: any) => Observable<any>;
  FolkSubscription: any;
  FolkControl = new FormControl();

  gettutorFolkACFn: (value: any) => Observable<any>;
  tutorFolkSubscription: any;
  tutorFolkControl = new FormControl();

  getReligionACFn: (value: any) => Observable<any>;
  ReligionSubscription: any;
  ReligionControl = new FormControl();

  getnatioNalityACFn: (value: any) => Observable<any>;
  natioNalitySubscription: any;
  natioNalityControl = new FormControl();

  getDistrictACFn: (value: any) => Observable<any>;
  DistrictSubscription: any;
  DistrictControl = new FormControl();

  getProvinceACFn: (value: any) => Observable<any>;
  ProvinceSubscription: any;
  ProvinceControl = new FormControl();

  getWardACFn: (value: any) => Observable<any>;
  WardSubscription: any;
  WardControl = new FormControl();

  getDisTypeOfDisabilitysACFn: (value: any) => Observable<any>;
  disTypeOfDisabilitysSubscription: any;
  disTypeOfDisabilitysControl = new FormControl();
  // getVillageACFn: (value: any) => Observable<any>;
  // VillageSubscription: any;
  // VillageControl = new FormControl();

  getSocialCommunicationACFn: (value: any) => Observable<any>;
  SocialCommunicationSubscription: any;
  SocialCommunicationControl = new FormControl();

  getSelfServiceACFn: (value: any) => Observable<any>;
  SelfServiceSubscription: any;
  SelfServiceControl = new FormControl();

  getEffectiveMedicalSupportACFn: (value: any) => Observable<any>;
  EffectiveMedicalSupportSubscription: any;
  EffectiveMedicalSupportControl = new FormControl();

  getNeedOfDisabilityACFn: (value: any) => Observable<any>;
  NeedOfDisabilitySubscription: any;
  NeedOfDisabilityControl = new FormControl();

  getInformationOfMedicalACFn: (value: any) => Observable<any>;
  InformationOfMedicalSubscription: any;
  InformationOfMedicalControl = new FormControl();

  getCaregiverACFn: (value: any) => Observable<any>;
  CaregiverSubscription: any;
  CaregiverControl = new FormControl();

  getLivingConditionACFn: (value: any) => Observable<any>;
  LivingConditionSubscription: any;
  LivingConditionControl = new FormControl();

  getTutorLivingConditionACFn: (value: any) => Observable<any>;
  TutorLivingConditionSubscription: any;
  TutorLivingConditionControl = new FormControl();

  getMotherLivingConditionACFn: (value: any) => Observable<any>;
  MotherLivingConditionSubscription: any;
  MotherLivingConditionControl = new FormControl();

  getFatherLivingConditionACFn: (value: any) => Observable<any>;
  FatherLivingConditionSubscription: any;
  FatherLivingConditionControl = new FormControl();

  getIncomeACFn: (value: any) => Observable<any>;
  IncomeSubscription: any;
  IncomeControl = new FormControl();

  getMainOfIncomeACFn: (value: any) => Observable<any>;
  MainOfIncomeSubscription: any;
  MainOfIncomeControl = new FormControl();

  getSupportCostACFn: (value: any) => Observable<any>;
  SupportCostSubscription: any;
  SupportCostControl = new FormControl();

  getEconomicIndependenceACFn: (value: any) => Observable<any>;
  EconomicIndependenceSubscription: any;
  EconomicIndependenceControl = new FormControl();

  getAcademicLevelACFn: (value: any) => Observable<any>;
  AcademicLevelSubscription: any;
  AcademicLevelControl = new FormControl();

  getEducationalStatusACFn: (value: any) => Observable<any>;
  EducationalStatusSubscription: any;
  EducationalStatusControl = new FormControl();

  getServiceParticipationACFn: (value: any) => Observable<any>;
  ServiceParticipationSubscription: any;
  ServiceParticipationControl = new FormControl();

  // getTypeOfEducationInvolveACFn: (value: any) => Observable<any>;
  // TypeOfEducationInvolveSubscription: any;
  // TypeOfEducationInvolveControl = new FormControl();

  getTypeOfOrganizationACFn: (value: any) => Observable<any>;
  TypeOfOrganizationSubscription: any;
  TypeOfOrganizationControl = new FormControl();

  getKindOfSupportACFn: (value: any) => Observable<any>;
  KindOfSupportSubscription: any;
  KindOfSupportControl = new FormControl();

  getCareerACFn: (value: any) => Observable<any>;
  CareerSubscription: any;
  CareerControl = new FormControl();

  getFamilyConcernLevelACFn: (value: any) => Observable<any>;
  FamilyConcernLevelSubscription: any;
  FamilyConcernLevelControl = new FormControl();

  getSuggestACFn: (value: any) => Observable<any>;
  SuggestSubscription: any;
  SuggestControl = new FormControl();

  getStudyModeACFn: (value: any) => Observable<any>;
  StudyModeSubscription: any;
  StudyModeControl = new FormControl();

  getModesOfEducationACFn: (value: any) => Observable<any>;
  ModesOfEducationSubscription: any;
  ModesOfEducationControl = new FormControl();

  getFatherEducationLevelsACFn: (value: any) => Observable<any>;
  FatherEducationLevelsSubscription: any;
  FatherEducationLevelsControl = new FormControl();

  getMotherEducationLevelsACFn: (value: any) => Observable<any>;
  MotherEducationLevelsSubscription: any;
  MotherEducationLevelsControl = new FormControl();

  getTutorEducationLevelsACFn: (value: any) => Observable<any>;
  TutorEducationLevelsSubscription: any;
  TutorEducationLevelsControl = new FormControl();

  getDisCausesACFn: (value: any) => Observable<any>;
  DisCausesSubscription: any;
  DisCausesControl = new FormControl();

  getCausesACFn: (value: any) => Observable<any>;
  causesSubscription: any;
  causesControl = new FormControl();

  getMaritalStatusACFn: (value: any) => Observable<any>;
  MaritalStatusSubscription: any;
  MaritalStatusControl = new FormControl();

  getEmploymentStatusACFn: (value: any) => Observable<any>;
  EmploymentStatusSubscription: any;
  EmploymentStatusControl = new FormControl();

  getLevelOfDevelopmentACFn: (value: any) => Observable<any>;
  LevelOfDevelopmentSubscription: any;
  LevelOfDevelopmentControl = new FormControl();

  getLevelACFn: (value: any) => Observable<any>;
  LevelSubscription: any;
  LevelControl = new FormControl();

  getNeedForEducationalSpACFn: (value: any) => Observable<any>;
  needForEducationalSpSubscription: any;
  needForEducationalSpControl = new FormControl();

  getNoiSinhACFn: (value: any) => Observable<any>;
  noiSinhSubscription: any;
  noiSinhControl = new FormControl();

  getThoiDiemKTACFn: (value: any) => Observable<any>;
  thoiDiemKTSubscription: any;
  thoiDiemKTControl = new FormControl();

  getChuongTrinhHocACFn: (value: any) => Observable<any>;
  chuongTrinhHocSubscription: any;
  chuongTrinhHocControl = new FormControl();

  getRelationshipACFn: (value: any) => Observable<any>;
  RelationshipSubscription: any;
  RelationshipControl = new FormControl();

  getTutorCareersACFn: (value: any) => Observable<any>;
  TutorCareersSubscription: any;
  TutorCareersControl = new FormControl();

  getTutorDistrictACFn: (value: any) => Observable<any>; TutorDistrictSubscription: any; TutorDistrictControl = new FormControl();
  getTutorProvinceACFn: (value: any) => Observable<any>; TutorProvinceSubscription: any; TutorProvinceControl = new FormControl();
  getTutorWardACFn: (value: any) => Observable<any>; TutorWardSubscription: any; TutorWardControl = new FormControl();
  ////////////////////////////////////////////////////////////////////////End-autoComplete////////////////////////////////////////////////////////////////////
  constructor(
    private modal: NzModalRef, private modalService: NzModalService, public utilService: UtilsService,
    private folkService: FolkService, private msg: NzMessageService, private religionService: ReligionService,
    private nationnalityService: NationnalityService, private provinceService: ProvinceService,
    private districtService: DistrictService, private wardService: WardService, private studentService: StudentService,
    private socialCommunicationService: SocialCommunicationService, private selfServiceService: SelfServiceService,
    private effectiveMedicalSupportService: EffectiveMedicalSupportService, private needOfDisabilityService: NeedOfDisabilityService,
    private informationOfMedicalService: InformationOfMedicalService, private caregiverService: CaregiverService,
    private livingConditionService: LivingConditionService, private incomeService: IncomeService,
    private mainOfIncomeService: MainOfIncomeService, private supportCostService: SupportCostService,
    private economicIndependenceService: EconomicIndependenceService, private academicLevelService: AcademicLevelService,
    private educationalStatusService: EducationalStatusService, private serviceParticipationService: ServiceParticipationService,
    private typeOfOrganizationService: TypeOfOrganizationService, private kindOfSupportService: KindOfSupportService,
    private careerService: CareerService, private familyConcernLevelService: FamilyConcernLevelService,
    private suggestService: SuggestService, private studyModeService: StudyModeService,
    private modesOfEducationService: ModesOfEducationService, private certificateTakeCareOfStudentService: CertificateTakeCareOfStudentService,
    private disbilityOfStudentService: DisbilityOfStudentService, private policyOfStudentService: PolicyOfStudentService,
    private studentLearningProcessService: StudentLearningProcessService, private staffStudentService: StaffStudentService,
    private studentLevelOfDevelopmentService: StudentLevelOfDevelopmentService, private EducationLevelsService: EducationLevelsService,
    private causesService: CaDisCausesService, private maritalStatusService: MaritalStatusService,
    private employmentStatusService: EmploymentStatusService, private levelOfDevelopmentService: LevelOfDevelopmentService,
    private CausesService: CaDisCausesService, private typeOfDisabilityservice: TypeOfDisabilityService,
    private levelService: LevelService, private studentInterventionStatusSearvice: CadisInterventionStatussService,
    private levelOfDevelopmentTypesService: LevelOfDevelopmentTypesService, private needForEducationalSpService: NeedForEducationalSpService,
    private publicService: SurveyPublicService, private noiSinhSearvice: NoiSinhService,
    private thoiDiemKhuyetTatSearvice: ThoiDiemKhuyetTatService, private chuongTrinhHocSearvice: ChuongTrinhHocService,
    private disSchoolLevelsService: SchoolLevelService, private relationshipService: RelationshipService,private tutorCareerService: TutorCareersService,
    private ptHtNktVanDongService: PtHtNktVanDongService,
  ) { }

  ngOnInit() {
    //Chiều cao màng hình
    this.maxHeight = window.innerHeight;
    //Tính chiều cao table
    this.height = this.maxHeight - 300 + 'px';
    //Tính chiều cao popup
    if (this.maxHeight > 950) {
      this.heightPopup = 700 + (this.maxHeight - 950);
    } else {
      this.heightPopup = 700 - (950 - this.maxHeight);
    }
    const currentUser = JSON.parse(localStorage.getItem('userSetting'));
    this.loadStudyMode();
    this.loadModesOfEducation();
    this.loadFolk();
    this.loadReligion();
    this.loadnatioNality();
    this.loadProvince();
    this.loadCauses();
    this.loadSocialCommunication();
    this.loadSelfService();
    this.loadEffectiveMedicalSupport();
    this.loadNeedOfDisability();
    this.loadInformationOfMedical();
    this.loadCaregiver();
    this.loadLivingCondition();
    this.loadIncome();
    this.loadMainOfIncome();
    this.loadSupportCost();
    this.loadEconomicIndependence();
    this.loadAcademicLevel();
    this.loadEducationalStatus();
    this.loadServiceParticipation();
    this.loadEducationLevel();
    // this.loadTypeOfEducationInvolve();
    this.loadTypeOfOrganization();
    this.loadKindOfSupport();
    this.loadCareer();
    this.loadFamilyConcernLevel();
    this.loadSuggest();
    this.loadTutorEducationLevels();
    this.loadTutorLivingCondition();
    this.loadMaritalStatus();
    this.loadEmploymentStatus();
    this.loadLevelOfDevelopment();
    this.loadDisTypeOfDisabilitys();
    this.loadLevel();
    this.loadCaDisEducationalStatuses();
    this.loadSchoolLevel();
    this.loadStudentInterventionStatus();
    this.loadlevelOfDevelopmentTypes();
    this.loadlevelOfDevelopment();
    this.getEducationalSupports();
    this.loadNeedForEducationalSp();
    this.getDisabilityPolicy();
    this.getInformationSources();
    this.getPublicLocalGovernmentCoordinations();
    this.getPublicCommunityCoordinations();
    this.loadtutorFolk();
    this.loadDisStudyMode();
    this.getStatuses();
    this.loadchuongTrinhHoc();
    this.loadnoiSinh();
    this.loadThoiDiemKT();
    this.loadRelationship();
    this.loadTutorCareers();
    this.loadTutorProvince();
    if (this.dataTransmission.id > 0) {
      if (currentUser.accountType != 3) {
        this.GetById(this.dataTransmission.id);
      } else {
        this.GetSelectById(this.dataTransmission.id);
      }
      // load chung chi
      this.loadChungChiCha(this.dataTransmission.id);
      this.loadChungChiMe(this.dataTransmission.id);
      this.loadChungChiTutor(this.dataTransmission.id);
      this.loadQTHT();
      this.loadGVPT();
      this.loadMDPT();
      this.loadKT();
      this.loadPolicy();

      this.isEditMode = true;
    } else {
      this.student = new Student();
      this.isEditMode = false;
    }
    this.getLevelDevelopmentByStudentId();
  }
  getLevelDevelopmentByStudentId() {
    this.studentService.getLevelDevelopmentByStudentId(this.dataTransmission.id).subscribe((res) => {
      this.lstLevelOfDeDto = res;
      res.forEach(element => {
        if (element.details.some(e => e.selected === true)) {
          const indexChange = element.details.findIndex(e => e.selected === true);
          this.lstLevelOfDeDtoSelected.push({ levelOfDevelopmentTypeId: element.id, levelOfDevelopmentId: element.details[indexChange].id });
        }
      });
    });
  }
  GetSelectById(id: number) {
    this.studentService.getById(id).subscribe((res: Student) => {
      if (res && res.avata) {
        this.studentService.getImage(res.avata).subscribe((img) => {
          if (img.img) {
            this.cardImageBase64 = 'data:image/jpg;base64,' + img.img;
            this.isImageSaved = true;
          }
        });
      }
      this.student = res;
      res.listStudentFacilitiesAndEquipmentNkt.forEach(element => {
        if (element) {
          this.listNeedForEducationalSp.map(res1 => {
            if (element === res1.id) {
              this.isNoteFacilities = res1.isNote;
            }
          })
        }
      });

      if (res.studyModeId) {
        this.studyModeService.getSelectById(res.studyModeId).subscribe((stu: HinhThucHoc) => {
          this.StudyModeControl.setValue({ id: stu.id, text: stu.name });
          this.loadDistrict();
        });
      }

      if (res.causeId) {
        this.causesService.getSelectPagingCausesById(res.causeId).subscribe((stu: any) => {
          this.causesControl.setValue({ id: stu.id, text: stu.name });
        });
      }
      if (res.modesOfEducationId) {
        this.modesOfEducationService.getSelectById(res.modesOfEducationId).subscribe((mod: ModesOfEducation) => {
          this.ModesOfEducationControl.setValue({ id: mod.id, text: mod.name });
          this.loadDistrict();
        });
      }
      if (res.tutorRelationshipId) {
        this.relationshipService.getSelectPagingById(res.tutorRelationshipId).subscribe((mod : any) => {
          this.RelationshipControl.setValue({ id: mod.id, text: mod.name,isNote : mod.isNote });
          this.isNoteRelationship =  this.RelationshipControl.value.isNote;
        });
      }
      if (res.provinceId) {
        this.provinceService.getSelectPagingProvinceById(res.provinceId).subscribe((pro: Province) => {
          this.ProvinceControl.setValue({ id: pro.id, text: pro.provinceName });
          this.loadDistrict();
          if (res.districtId) {
            this.districtService.getSelectPagingDistrictById(res.districtId).subscribe((dis: District) => {
              this.DistrictControl.setValue({ id: dis.id, text: dis.districtName });
              this.loadWard();
              if (res.wardId) {
                this.wardService.getSelectPagingWardById(res.wardId).subscribe((war: Ward) => {
                  this.WardControl.setValue({ id: war.id, text: war.wardName })
                });
              }
            });

          }
        });
      }

      if (res.tutorProvinceId) {
        this.provinceService.getSelectPagingProvinceById(res.tutorProvinceId).subscribe((pro: Province) => {
          this.TutorProvinceControl.setValue({ id: pro.id, text: pro.provinceName });
          this.loadTutorDistrict();
          if (res.tutorDistrictId) {
            this.districtService.getSelectPagingDistrictById(res.tutorDistrictId).subscribe((dis: District) => {
              this.TutorDistrictControl.setValue({ id: dis.id, text: dis.districtName });
              this.loadTutorWard();
              if (res.tutorWardId) {
                this.wardService.getSelectPagingWardById(res.tutorWardId).subscribe((war: Ward) => {
                  this.TutorWardControl.setValue({ id: war.id, text: war.wardName })
                });
              }
            });
          }
        });
      }

      if (res.folkId) {
        this.folkService.getSelectPagingFolkById(res.folkId).subscribe((fol: Folk) => {
          this.FolkControl.setValue({ id: fol.id, text: fol.folkName })
        });
      }

      if (res.tutorCareerId) {
        this.tutorCareerService.getSelectById(res.tutorCareerId).subscribe((tu: any) => {
          this.TutorCareersControl.setValue({ id: tu.id, text: tu.name,isNote : tu.isNote })
          this.isNote = this.TutorCareersControl.value.isNote;

        });
      }


      if (res.religionId) {
        this.religionService.getSelectPagingReligionsById(res.religionId).subscribe((rel: Religion) => {
          this.ReligionControl.setValue({ id: rel.id, text: rel.nationalityName })
        });
      }


      if (res.nationalityId) {
        this.nationnalityService.getSelectPagingNationnalityById(res.nationalityId).subscribe((nat: Nationality) => {
          this.natioNalityControl.setValue({ id: nat.id, text: nat.nationalityName })
        });
      }


      if (this.student.avata && this.student.avata != '') {
        this.loadAvataPath = this.student.avata;
      }
      if (this.studentAvatar) {
        if (this.student.avata == null) this.removeAvatar();
        else if (this.student.avata && this.student.avata != '') {
          this.studentAvatar.nativeElement.src = this.student.avata;
        }
      }
      //Nơi sinh
      if (res.placeOfBirthId) {
        this.noiSinhSearvice.getSelectPagingNoiSinhById(res.placeOfBirthId).subscribe((ca: CategoryModel) => {
          this.noiSinhControl.setValue({ id: ca.id, text: ca.name });
        });
      }
      //Chương trình học
      // if(res.studyProgramsId){
      //   this.chuongTrinhHocSearvice.getSelectPagingNoiSinhById(res.studyProgramsId).subscribe((ca: CategoryModel) => {
      //     this.chuongTrinhHocControl.setValue({ id: ca.id, text: ca.name });
      //   });
      // }
      //
      //Thời điểm KT
      if (res.disabilityMomentId) {
        this.thoiDiemKhuyetTatSearvice.getSelectPagingNoiSinhById(res.disabilityMomentId).subscribe((ca: CategoryModel) => {
          this.thoiDiemKTControl.setValue({ id: ca.id, text: ca.name });
        });
      }
      if (res.caregiverId) {
        this.caregiverService.getSelectById(res.caregiverId).subscribe((ca: any) => {
          this.CaregiverControl.setValue({ id: ca.id, text: ca.name,isNote: ca.isRequiredNote});
          this.isNoteCaregiver = this.CaregiverControl.value.isNote;
        });
      }
      if (res.typeOfDisabilityId) {
        this.typeOfDisabilityservice.GetSelectPagingById(res.typeOfDisabilityId).subscribe((ca: any) => {
          this.disTypeOfDisabilitysControl.setValue({ id: ca.id, text: ca.typeOfDisabilityName,isRequiredNote:ca.isRequiredNote });
          this.isDisability = this.disTypeOfDisabilitysControl.value.isRequiredNote;
        });
      }
      //Mức độ KT
      if (res.levelId) {
        this.levelService.getSelectPagingById(res.levelId).subscribe((ca: any) => {
          this.LevelControl.setValue({ id: ca.id, text: ca.typeOfDisabilityName });
        });
      }
      //Cấp học
      if (res.schoolLevelId) {
        this.disSchoolLevelsService.getSelectPagingSchoolLevelsById(res.schoolLevelId).subscribe((ca: any) => {
          this.SchoolLevelControl.setValue({ id: ca.id, text: ca.schoolLevelName });
        });
      }
      if (res.studyModeId) {
        this.modesOfEducationService.getSelectById(res.studyModeId).subscribe((ca: any) => {
          this.disStudyModeControl.setValue({ id: ca.id, text: ca.name });
        });
      }
      if (res.educationLevelId) {
        this.EducationLevelsService.getSelectPagingEducationLevelById(res.educationLevelId).subscribe((ca: any) => {
          this.EducationLevelControl.setValue({ id: ca.id, text: ca.name });
        });
      }
      if (res.tutorLivingConditionId) {
        this.livingConditionService.getSelectById(res.tutorLivingConditionId).subscribe((ca: CategoryModel) => {
          this.TutorLivingConditionControl.setValue({ id: ca.id, text: ca.name })
        });
      }
      //tình trạng hôn nhân
      if (res.maritalStatusId) {
        this.maritalStatusService.getSelectPagingById(res.maritalStatusId).subscribe((ca: CategoryModel) => {
          this.MaritalStatusControl.setValue({ id: ca.id, text: ca.name });
        });
      }
      if (res.employmentStatusId) {
        this.employmentStatusService.getSelectPagingById(res.employmentStatusId).subscribe((ca: CategoryModel) => {
          this.EmploymentStatusControl.setValue({ id: ca.id, text: ca.name });
        });
      }
      if (res.tutorEducationLevelId) {
        this.EducationLevelsService.getSelectPagingEducationLevelById(res.tutorEducationLevelId).subscribe((ca: CategoryModel) => {
          this.TutorEducationLevelsControl.setValue({ id: ca.id, text: ca.name });
        });
      }

      if (res.tutorFolkId) {
        this.folkService.getSelectPagingFolkById(res.tutorFolkId).subscribe((fol: Folk) => {
          this.tutorFolkControl.setValue({ id: fol.id, text: fol.folkName })
        });
      }
      this.studentInterventionStatusSearvice
        .getSelectPaging({ PageIndex: 1, PageSize: 100 })
        .subscribe(res2 => {
          this.listStudentInterventionStatus = res2.results.map(x => ({ value: x.id, label: x.name, checked: false, isRequiredNote: x.isRequiredNote }));
          if (res.listStudentInterventionStatus.length > 0) {
            res.listStudentInterventionStatus.forEach(element => {
              this.listStudentInterventionStatus.forEach(element2 => {
                if (element === element2.value) {
                  element2.checked = true;
                }
              });
            });
          }
        });
      this.levelOfDevelopmentTypesService
        .getSelectPaging({ PageIndex: 1, PageSize: 100 })
        .subscribe(res2 => {
          res2.results.sort(function (a, b) { return a.displayOrder - b.displayOrder });
          this.listlevelOfDevelopmentTypes = res2.results.map(x => ({ id: x.id, name: x.name, levelOfDevelopmentId: 0, levelOfDevelopmentTypeId: x.id }));
          if (res.listStudentLevelOfDevelopment.length > 0) {
            this.listlevelOfDevelopmentTypes.forEach(item => {
              res.listStudentLevelOfDevelopment.forEach(value => {
                if (item.levelOfDevelopmentTypeId === value.levelOfDevelopmentTypeId) {
                  item.levelOfDevelopmentId = value.levelOfDevelopmentId;
                }
              });
            });
          }
        });
      //C.
      if (res.listStudentEducationSupport.length > 0) {
        this.needForEducationalSpService.getSelectPaging({ PageIndex: 1, PageSize: 100 }).subscribe(res2 => {
          res2.results.sort(function (a, b) { return a.displayOrder - b.displayOrder });
          this.listEducationalSupports = res2.results.map(x => ({ value: x.id, name: x.name, checked: false, isApprentice: x.isApprentice, isEarlyIntervention: x.isEarlyIntervention, isEducationFacilitiesEquipment: x.isEducationFacilitiesEquipment, isRequiredNote: x.isRequiredNote }));
          res.listStudentEducationSupport.forEach(id => {
            this.listEducationalSupports.forEach(value => {
              if (value.value === id) {
                value.checked = true;
              }
              // if(res.modesOfEducationId){
              //   this.modesOfEducationService.getSelectById(res.modesOfEducationId).subscribe(q=>{
              //     this.ModesOfEducationsControl.setValue({id:q.id , text: q.name});
              //   });
              // }
            });
          });

        });
      } else {
        this.needForEducationalSpService.getSelectPaging({ PageIndex: 1, PageSize: 100 }).subscribe(res2 => {
          res2.results.sort(function (a, b) { return a.displayOrder - b.displayOrder });
          this.listEducationalSupports = res2.results.map(x => ({ value: x.id, name: x.name, checked: false, isApprentice: x.isApprentice, isEarlyIntervention: x.isEarlyIntervention, isEducationFacilitiesEquipment: x.isEducationFacilitiesEquipment, isRequiredNote: x.isRequiredNote }));
        });
      }
      //Tiếp nhận chính sách từ nguồn
      if (res.listStudentInformationSource.length > 0) {
        this.publicService.getPublicInformationSources({ PageIndex: 1, PageSize: 100 }).subscribe(res2 => {
          res2.results.sort(function (a, b) { return a.displayOrder - b.displayOrder });
          this.listInformationSources = res2.results.map(x => ({ value: x.id, name: x.name, checked: x.id === id ? true : false, isRequiredNote: x.isRequiredNote }));
          res.listStudentInformationSource.forEach(id => {
            this.listInformationSources.forEach(value => {
              if (value.value === id) {
                value.checked = true;
              }
            });
          });
        });
      } else {
        this.publicService.getPublicInformationSources({ PageIndex: 1, PageSize: 100 }).subscribe(res2 => {
          res2.results.sort(function (a, b) { return a.displayOrder - b.displayOrder });
          this.listInformationSources = res2.results.map(x => ({ value: x.id, name: x.name, checked: false, isRequiredNote: x.isRequiredNote }));
        });
      }
      if (res.listStudentDisabilityPolicy.length > 0) {
        this.publicService.getPublicDisabilityPolicy({ PageIndex: 1, PageSize: 100 }).subscribe(res2 => {
          res2.results.sort(function (a, b) { return a.displayOrder - b.displayOrder });
          this.listDisabilityPolicy = res2.results.map(x => ({ value: x.id, name: x.name, checked: id === x.id ? true : false, isRequiredNote: x.isRequiredNote }));
          res.listStudentDisabilityPolicy.forEach(id => {
            this.listDisabilityPolicy.forEach(value => {
              if (value.value === id) {
                value.checked = true;
              }
            });
          });
        });
      } else {
        this.publicService.getPublicDisabilityPolicy({ PageIndex: 1, PageSize: 100 }).subscribe(res2 => {
          res2.results.sort(function (a, b) { return a.displayOrder - b.displayOrder });
          this.listDisabilityPolicy = res2.results.map(x => ({ value: x.id, name: x.name, checked: false, isRequiredNote: x.isRequiredNote }));
        });
      }
    });
  }
  loadChungChiCha(idStudent: number) {
    this.certificateTakeCareOfStudentService.get({ DisTutorType: 1, StudentId: idStudent }).subscribe(res => {
      this.listChungChiCha = res.results ? res.results : [];
    });
  }
  loadChungChiMe(idStudent: number) {
    this.certificateTakeCareOfStudentService.get({ DisTutorType: 2, StudentId: idStudent }).subscribe(res => {
      this.listChungChiMe = res.results ? res.results : [];
    });
  }
  loadChungChiTutor(idStudent: number) {
    this.certificateTakeCareOfStudentService.get({ DisTutorType: 3, StudentId: idStudent }).subscribe(res => {
      this.listChungChiTutor = res.results ? res.results : [];
    });
  }
  loadQTHT() {
    this.studentLearningProcessService.get({ studentId: this.dataTransmission.id }).subscribe(res => {
      this.listQTHT = res.results ? res.results : [];
      this.setStatusEducation();
    });
  }
  loadGVPT() {
    this.staffStudentService.GetSelectPagingByStudent({ studentId: this.dataTransmission.id, PageIndex: 1, PageSize: 20 }).subscribe(res => {
      this.listGVPT = res.results ? res.results : [];
    });
  }
  loadKT() {
    this.disbilityOfStudentService.get({ studentId: this.dataTransmission.id }).subscribe(res => {
      this.listKT = res.results ? res.results : [];
    });
  }
  loadPolicy() {
    this.policyOfStudentService.get({ studentId: this.dataTransmission.id }).subscribe(res => {
      this.listPolicy = res.results ? res.results : [];
    });
  }
  loadMDPT() {
    this.studentLevelOfDevelopmentService.get({ studentId: this.dataTransmission.id }).subscribe(res => {
      this.listMDPT = res.results ? res.results : [];
    });
  }
  GetById(id: number) {
    this.studentService.getById(id).subscribe((res: Student) => {
      if (res && res.avata) {
        this.studentService.getImage(res.avata).subscribe((img) => {
          if (img.img) {
            this.cardImageBase64 = 'data:image/jpg;base64,' + img.img;
            this.isImageSaved = true;
          }
        });
      }
      this.student = res;
      res.listStudentFacilitiesAndEquipmentNkt.forEach(element => {
        if (element) {
          this.listNeedForEducationalSp.map(res1 => {
            if (element === res1.id) {
              this.isNoteFacilities = res1.isNote;
            }
          })
        }
      });
      if (res.causeId) {
        this.causesService.getSelectPagingCausesById(res.causeId).subscribe((stu: any) => {
          this.causesControl.setValue({ id: stu.id, text: stu.name });
        });
      }
      if (res.tutorRelationshipId) {
        this.relationshipService.getSelectPagingById(res.tutorRelationshipId).subscribe((mod : any) => {
          this.RelationshipControl.setValue({ id: mod.id, text: mod.name,isNote : mod.isNote });
          this.isNoteRelationship =  this.RelationshipControl.value.isNote;
        });
      }
      if (res.studyModeId) {
        this.studyModeService.getSelectById(res.studyModeId).subscribe((stu: HinhThucHoc) => {
          this.StudyModeControl.setValue({ id: stu.id, text: stu.name });
        });
      }
      if (res.modesOfEducationId) {
        this.modesOfEducationService.getSelectById(res.modesOfEducationId).subscribe((mod: ModesOfEducation) => {
          this.ModesOfEducationControl.setValue({ id: mod.id, text: mod.name });
        });
      }
      if (res.caregiverId) {
        this.caregiverService.getSelectById(res.caregiverId).subscribe((ca: any) => {
          this.CaregiverControl.setValue({ id: ca.id, text: ca.name,isNote: ca.isRequiredNote});
          this.isNoteCaregiver = this.CaregiverControl.value.isNote;

        });
      }
      if (res.provinceId) {
        this.provinceService.getSelectPagingProvinceById(res.provinceId).subscribe((pro: Province) => {
          this.ProvinceControl.setValue({ id: pro.id, text: pro.provinceName });
          this.loadDistrict();
          if (res.districtId) {
            this.districtService.getSelectPagingDistrictById(res.districtId).subscribe((dis: District) => {
              this.DistrictControl.setValue({ id: dis.id, text: dis.districtName });
              this.loadWard();
              if (res.wardId) {
                this.wardService.getSelectPagingWardById(res.wardId).subscribe((war: Ward) => {
                  this.WardControl.setValue({ id: war.id, text: war.wardName })
                });
              }
            });
          }
        });
      }
      if (res.tutorProvinceId) {
        this.provinceService.getSelectPagingProvinceById(res.tutorProvinceId).subscribe((pro: Province) => {
          this.TutorProvinceControl.setValue({ id: pro.id, text: pro.provinceName });
          this.loadTutorDistrict();
          if (res.tutorDistrictId) {
            this.districtService.getSelectPagingDistrictById(res.tutorDistrictId).subscribe((dis: District) => {
              this.TutorDistrictControl.setValue({ id: dis.id, text: dis.districtName });
              this.loadTutorWard();
              if (res.tutorWardId) {
                this.wardService.getSelectPagingWardById(res.tutorWardId).subscribe((war: Ward) => {
                  this.TutorWardControl.setValue({ id: war.id, text: war.wardName })
                });
              }
            });
          }
        });
      }
      if (res.folkId) {
        this.folkService.getSelectPagingFolkById(res.folkId).subscribe((fol: Folk) => {
          this.FolkControl.setValue({ id: fol.id, text: fol.folkName })
        });
      }

      if (res.tutorFolkId) {
        this.folkService.getSelectPagingFolkById(res.tutorFolkId).subscribe((fol: Folk) => {
          this.tutorFolkControl.setValue({ id: fol.id, text: fol.folkName })
        });
      }

      if (res.tutorCareerId) {
        this.tutorCareerService.getSelectById(res.tutorCareerId).subscribe((tu: any) => {
          this.TutorCareersControl.setValue({ id: tu.id, text: tu.name,isNote : tu.isNote })
          this.isNote = this.TutorCareersControl.value.isNote;

        });
      }

      if (res.religionId) {
        this.religionService.getSelectPagingReligionsById(res.religionId).subscribe((rel: Religion) => {
          this.ReligionControl.setValue({ id: rel.id, text: rel.nationalityName })
        });
      }

      if (res.nationalityId) {
        this.nationnalityService.getSelectPagingNationnalityById(res.nationalityId).subscribe((nat: Nationality) => {
          this.natioNalityControl.setValue({ id: nat.id, text: nat.nationalityName })
        });
      }

      if (this.student.avata && this.student.avata != '') {
        this.loadAvataPath = this.student.avata;
      }
      if (this.studentAvatar) {
        if (this.student.avata == null) this.removeAvatar();
        else if (this.student.avata && this.student.avata != '') {
          this.studentAvatar.nativeElement.src = this.student.avata;
        }
      }
      if (res.tutorLivingConditionId) {
        this.livingConditionService.getSelectById(res.tutorLivingConditionId).subscribe((ca: CategoryModel) => {
          this.TutorLivingConditionControl.setValue({ id: ca.id, text: ca.name })
        });
      }
      //tình trạng hôn nhân
      if (res.maritalStatusId) {
        this.maritalStatusService.getSelectPagingById(res.maritalStatusId).subscribe((ca: CategoryModel) => {
          this.MaritalStatusControl.setValue({ id: ca.id, text: ca.name });
        });
      }
      if (res.employmentStatusId) {
        this.employmentStatusService.getSelectPagingById(res.employmentStatusId).subscribe((ca: CategoryModel) => {
          this.EmploymentStatusControl.setValue({ id: ca.id, text: ca.name });
        });
      }
      //Nơi sinh
      if (res.placeOfBirthId) {
        this.noiSinhSearvice.getSelectPagingNoiSinhById(res.placeOfBirthId).subscribe((ca: CategoryModel) => {
          this.noiSinhControl.setValue({ id: ca.id, text: ca.name });
        });
      }
      //Chương trình học
      // if(res.studyProgramsId){
      //   this.chuongTrinhHocSearvice.getSelectPagingNoiSinhById(res.studyProgramsId).subscribe((ca: CategoryModel) => {
      //     this.chuongTrinhHocControl.setValue({ id: ca.id, text: ca.name });
      //   });
      // }
      //
      //Thời điểm KT
      if (res.disabilityMomentId) {
        this.thoiDiemKhuyetTatSearvice.getSelectPagingNoiSinhById(res.disabilityMomentId).subscribe((ca: CategoryModel) => {
          this.thoiDiemKTControl.setValue({ id: ca.id, text: ca.name });
        });
      }
      if (res.typeOfDisabilityId) {
        this.typeOfDisabilityservice.GetSelectPagingById(res.typeOfDisabilityId).subscribe((ca: any) => {
          this.disTypeOfDisabilitysControl.setValue({ id: ca.id, text: ca.typeOfDisabilityName,isRequiredNote:ca.isRequiredNote });
          this.isDisability = this.disTypeOfDisabilitysControl.value.isRequiredNote;
        });
      }
      //Mức độ KT
      if (res.levelId) {
        this.levelService.getSelectPagingById(res.levelId).subscribe((ca: any) => {
          this.LevelControl.setValue({ id: ca.id, text: ca.typeOfDisabilityName });
        });
      }
      //Cấp học
      if (res.schoolLevelId) {
        this.disSchoolLevelsService.getSelectPagingSchoolLevelsById(res.schoolLevelId).subscribe((ca: any) => {
          this.SchoolLevelControl.setValue({ id: ca.id, text: ca.schoolLevelName });
        });
      }
      if (res.studyModeId) {
        this.modesOfEducationService.getSelectById(res.studyModeId).subscribe((ca: any) => {
          this.disStudyModeControl.setValue({ id: ca.id, text: ca.name });
        });
      }
      if (res.educationLevelId) {
        this.EducationLevelsService.getSelectPagingEducationLevelById(res.educationLevelId).subscribe((ca: any) => {
          this.EducationLevelControl.setValue({ id: ca.id, text: ca.name });
        });
      }
      if (res.tutorEducationLevelId) {
        this.EducationLevelsService.getSelectPagingEducationLevelById(res.tutorEducationLevelId).subscribe((ca: CategoryModel) => {
          this.TutorEducationLevelsControl.setValue({ id: ca.id, text: ca.name });
        });
      }
      this.studentInterventionStatusSearvice
        .getSelectPaging({ PageIndex: 1, PageSize: 100 })
        .subscribe(res2 => {
          this.listStudentInterventionStatus = res2.results.map(x => ({ value: x.id, label: x.name, checked: false, isRequiredNote: x.isRequiredNote }));
          if (res.listStudentInterventionStatus.length > 0) {
            res.listStudentInterventionStatus.forEach(element => {
              this.listStudentInterventionStatus.forEach(element2 => {
                if (element === element2.value) {
                  element2.checked = true;
                }
              });
            });
          }
        });
      this.levelOfDevelopmentTypesService
        .getSelectPaging({ PageIndex: 1, PageSize: 100 })
        .subscribe(res2 => {
          res2.results.sort(function (a, b) { return a.displayOrder - b.displayOrder });
          this.listlevelOfDevelopmentTypes = res2.results.map(x => ({ id: x.id, name: x.name, levelOfDevelopmentId: 0, levelOfDevelopmentTypeId: x.id, idDev: 0 }));
          if (res.listStudentLevelOfDevelopment.length > 0) {
            this.listlevelOfDevelopmentTypes.forEach(item => {
              res.listStudentLevelOfDevelopment.forEach(value => {
                // if(value.id)
                if (item.levelOfDevelopmentTypeId === value.levelOfDevelopmentTypeId) {
                  item.idDev = value.id;
                  item.levelOfDevelopmentId = value.levelOfDevelopmentId;
                }
              });
            });
          }
        });
      //C.
      if (res.listStudentEducationSupport.length > 0) {
        this.needForEducationalSpService.getSelectPaging({ PageIndex: 1, PageSize: 100 }).subscribe(res2 => {
          res2.results.sort(function (a, b) { return a.displayOrder - b.displayOrder });
          this.listEducationalSupports = res2.results.map(x => ({ value: x.id, name: x.name, checked: false, isApprentice: x.isApprentice, isEarlyIntervention: x.isEarlyIntervention, isEducationFacilitiesEquipment: x.isEducationFacilitiesEquipment, isRequiredNote: x.isRequiredNote }));
          res.listStudentEducationSupport.forEach(id => {
            this.listEducationalSupports.forEach(value => {
              if (value.value === id) {
                value.checked = true;
              }
              // if(res.modesOfEducationId){
              //   this.modesOfEducationService.getSelectById(res.modesOfEducationId).subscribe(q=>{
              //     this.ModesOfEducationsControl.setValue({id:q.id , text: q.name});
              //   });
              // }
            });
          });
        });
      } else {
        this.needForEducationalSpService.getSelectPaging({ PageIndex: 1, PageSize: 100 }).subscribe(res2 => {
          res2.results.sort(function (a, b) { return a.displayOrder - b.displayOrder });
          this.listEducationalSupports = res2.results.map(x => ({ value: x.id, name: x.name, checked: false, isApprentice: x.isApprentice, isEarlyIntervention: x.isEarlyIntervention, isEducationFacilitiesEquipment: x.isEducationFacilitiesEquipment, isRequiredNote: x.isRequiredNote }));
        });
      }
      //
      if (res.listStudentDisabilityPolicy.length > 0) {
        this.publicService.getPublicDisabilityPolicy({ PageIndex: 1, PageSize: 100 }).subscribe(res2 => {
          res2.results.sort(function (a, b) { return a.displayOrder - b.displayOrder });
          this.listDisabilityPolicy = res2.results.map(x => ({ value: x.id, name: x.name, checked: id === x.id ? true : false, isRequiredNote: x.isRequiredNote }));
          res.listStudentDisabilityPolicy.forEach(id => {
            this.listDisabilityPolicy.forEach(value => {
              if (value.value === id) {
                value.checked = true;
              }
            });
          });
        });
      } else {
        this.publicService.getPublicDisabilityPolicy({ PageIndex: 1, PageSize: 100 }).subscribe(res2 => {
          res2.results.sort(function (a, b) { return a.displayOrder - b.displayOrder });
          this.listDisabilityPolicy = res2.results.map(x => ({ value: x.id, name: x.name, checked: false, isRequiredNote: x.isRequiredNote }));
        });
      }
      //Tiếp nhận chính sách từ nguồn
      if (res.listStudentInformationSource.length > 0) {
        this.publicService.getPublicInformationSources({ PageIndex: 1, PageSize: 100 }).subscribe(res2 => {
          res2.results.sort(function (a, b) { return a.displayOrder - b.displayOrder });
          this.listInformationSources = res2.results.map(x => ({ value: x.id, name: x.name, checked: x.id === id ? true : false, isRequiredNote: x.isRequiredNote }));
          res.listStudentInformationSource.forEach(id => {
            this.listInformationSources.forEach(value => {
              if (value.value === id) {
                value.checked = true;
              }
            });
          });
        });
      } else {
        this.publicService.getPublicInformationSources({ PageIndex: 1, PageSize: 100 }).subscribe(res2 => {
          res2.results.sort(function (a, b) { return a.displayOrder - b.displayOrder });
          this.listInformationSources = res2.results.map(x => ({ value: x.id, name: x.name, checked: false, isRequiredNote: x.isRequiredNote }));
        });
      }
    });
  }
  notification(response) {
    if (response.statusCode === 0) {
      this.msg.success('Cập nhật thông tin: ' + response.message);
    } else {
      this.msg.error('Lỗi: ' + response.message);
    }
  }
  UpdateClose() {
    this.updatelist();
    if (this.utilService.notifyValidateNgModel(this.student, this.labelElement)) {
      this.studentService.addOrUpdate(this.student).subscribe((res) => {
        if (res.statusCode == 0) {
          this.notification(res);
          this.close();
        } else {
          this.notification(res);
        }
      })
    }
  }
  clearForm() {
    this.student = new Student();
    this.ProvinceControl.value.id = this.ProvinceControl.setValue(null);
    this.DistrictControl.value.id = this.DistrictControl.setValue(null);
    this.WardControl.value.id = this.WardControl.setValue(null);
  }
  close() {
    this.destroyModal();
  }
  destroyModal(): void {
    this.modal.destroy(true);
  }

  uploadFile(event) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      var pattern = /image-*/;
      var reader = new FileReader();
      if (!file.type.match(pattern)) {
        alert('invalid format');
        return;
      }
      this.studentService.importAvata(file).subscribe(res => {
        if (res.length > 0) {
          this.student.avata = res[res.length - 1].filePath;
          reader.onloadend = this._handleReaderLoaded.bind(this);
          reader.readAsDataURL(file);
        }
      });

    }
  }

  _handleReaderLoaded(e) {
    let reader = e.target;
    var base64result = reader.result.substr(reader.result.indexOf(',') + 1);
    let avatar = 'data:image/jpeg;base64,' + base64result;
    if (this.studentAvatar) {
      this.studentAvatar.nativeElement.src = avatar;
    }
    this.fileHinh = avatar;
  }

  removeAvatar() {
    if (this.studentAvatar) {
      this.studentAvatar.nativeElement.src = 'assets/img/no-avatar.png';
      this.student.avata = '';
    }
  }
  ////////////////////////////////////////////////////////////////////////autoComplete////////////////////////////////////////////////////////////////////
  valueIfHas(control: FormControl) {
    if (control.value && typeof control.value != 'string') return control.value.id;
    return '';
  }
  loadFolk() {
    this.getFolkACFn = (value: any) => this.folkService.getFolkSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.folkName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );

    if (!this.FolkSubscription) this.FolkSubscription = this.FolkControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'folkId', this.FolkControl.value);
    });
  }
  changeFolk(control: FormControl) {
    this.FolkControl = control;
  }

  loadReligion() {
    this.getReligionACFn = (value: any) => this.religionService.getReligionsSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.nationalityName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.ReligionSubscription) this.ReligionSubscription = this.ReligionControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'religionId', this.ReligionControl.value);
    });
  }
  changeReligion(control: FormControl) {
    this.ReligionControl = control;
  }

  loadCauses() {
    this.getCausesACFn = (value: any) => this.causesService.getCausesSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.causesSubscription) this.causesSubscription = this.causesControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'causeId', this.causesControl.value);
    });
  }
  changeCauses(control: FormControl) {
    this.causesControl = control;
  }
  loadnatioNality() {
    this.getnatioNalityACFn = (value: any) => this.nationnalityService.getNationnalitySelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.nationalityName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.natioNalitySubscription) this.natioNalitySubscription = this.natioNalityControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'nationalityId', this.natioNalityControl.value);
    });
  }
  changenatioNality(control: FormControl) {
    this.natioNalityControl = control;
  }

  ///////////////////////////////////////////////////////////////////////////autoComplete thông tin giảng dạy/////////////////////////////////////////////////////

  loadProvince() {
    this.getProvinceACFn = (value: any) => this.provinceService.getProvinceSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.provinceName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.ProvinceSubscription) this.ProvinceSubscription = this.ProvinceControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'provinceId', this.ProvinceControl.value);
    });
  }
  changeProvince(control: FormControl) {
    this.ProvinceControl = control;
    this.loadDistrict();
    this.DistrictControl.setValue(null);
  }

  loadDistrict() {
    this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({ searchTerm: value, ProvinceId: this.valueIfHas(this.ProvinceControl), PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.DistrictSubscription) this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'districtId', this.DistrictControl.value);
    });
  }
  changeDistrict(control: FormControl) {
    this.DistrictControl = control;
    this.loadWard();
    this.WardControl.setValue(null);
  }

  loadWard() {
    this.getWardACFn = (value: any) => this.wardService.getWardSelectPaging({ searchTerm: value, DistrictId: this.valueIfHas(this.DistrictControl), PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.wardName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.WardSubscription) this.WardSubscription = this.WardControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'wardId', this.WardControl.value);
    });
  }
  changeWard(control: FormControl) {
    this.WardControl = control;
  }


  ///////////////////////////////////////////////////////////////////////////autoComplete thông tin khuyet tat/////////////////////////////////////////////////////
  loadSocialCommunication() {
    this.getSocialCommunicationACFn = (value: any) => this.socialCommunicationService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.SocialCommunicationSubscription) this.SocialCommunicationSubscription = this.SocialCommunicationControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'socialCommunicationId', this.SocialCommunicationControl.value);
    });
  }
  changeSocialCommunication(control: FormControl) {
    this.SocialCommunicationControl = control;
  }

  loadSelfService() {
    this.getSelfServiceACFn = (value: any) => this.selfServiceService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.SelfServiceSubscription) this.SelfServiceSubscription = this.SelfServiceControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'selfServiceId', this.SelfServiceControl.value);
    });
  }
  changeSelfService(control: FormControl) {
    this.SelfServiceControl = control;
  }

  loadEffectiveMedicalSupport() {
    this.getEffectiveMedicalSupportACFn = (value: any) => this.effectiveMedicalSupportService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.EffectiveMedicalSupportSubscription) this.EffectiveMedicalSupportSubscription = this.EffectiveMedicalSupportControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'effectiveMedicalSupportId', this.EffectiveMedicalSupportControl.value);
    });
  }
  changeEffectiveMedicalSupport(control: FormControl) {
    this.EffectiveMedicalSupportControl = control;
  }

  loadNeedOfDisability() {
    this.getNeedOfDisabilityACFn = (value: any) => this.needOfDisabilityService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.NeedOfDisabilitySubscription) this.NeedOfDisabilitySubscription = this.NeedOfDisabilityControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'needOfDisabilityId', this.NeedOfDisabilityControl.value);
    });
  }
  changeNeedOfDisability(control: FormControl) {
    this.NeedOfDisabilityControl = control;
  }

  loadInformationOfMedical() {
    this.getInformationOfMedicalACFn = (value: any) => this.informationOfMedicalService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.InformationOfMedicalSubscription) this.InformationOfMedicalSubscription = this.InformationOfMedicalControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'informationOfMedicalId', this.InformationOfMedicalControl.value);
    });
  }
  changeInformationOfMedical(control: FormControl) {
    this.InformationOfMedicalControl = control;
  }

  loadCaregiver() {
    this.getCaregiverACFn = (value: any) => this.caregiverService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.CaregiverSubscription) this.CaregiverSubscription = this.CaregiverControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'caregiverId', this.CaregiverControl.value);
    });
  }
  changeCaregiver(control: FormControl) {
    this.CaregiverControl = control;
  }

  loadLivingCondition() {
    this.getLivingConditionACFn = (value: any) => this.livingConditionService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.LivingConditionSubscription) this.LivingConditionSubscription = this.LivingConditionControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'livingConditionId', this.LivingConditionControl.value);
    });
  }
  changeLivingCondition(control: FormControl) {
    this.LivingConditionControl = control;
  }

  loadIncome() {
    this.getIncomeACFn = (value: any) => this.incomeService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.IncomeSubscription) this.IncomeSubscription = this.IncomeControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'incomeId', this.IncomeControl.value);
    });
  }
  changeIncome(control: FormControl) {
    this.IncomeControl = control;
  }

  loadMainOfIncome() {
    this.getMainOfIncomeACFn = (value: any) => this.mainOfIncomeService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.MainOfIncomeSubscription) this.MainOfIncomeSubscription = this.MainOfIncomeControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'mainOfIncomeId', this.MainOfIncomeControl.value);
    });
  }
  changeMainOfIncome(control: FormControl) {
    this.MainOfIncomeControl = control;
  }

  loadSupportCost() {
    this.getSupportCostACFn = (value: any) => this.supportCostService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.SupportCostSubscription) this.SupportCostSubscription = this.SupportCostControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'supportCostId', this.SupportCostControl.value);
    });
  }
  changeSupportCost(control: FormControl) {
    this.SupportCostControl = control;
  }

  loadEconomicIndependence() {
    this.getEconomicIndependenceACFn = (value: any) => this.economicIndependenceService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.EconomicIndependenceSubscription) this.EconomicIndependenceSubscription = this.EconomicIndependenceControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'economicIndependenceId', this.EconomicIndependenceControl.value);
    });
  }
  changeEconomicIndependence(control: FormControl) {
    this.EconomicIndependenceControl = control;
  }

  loadAcademicLevel() {
    this.getAcademicLevelACFn = (value: any) => this.academicLevelService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.AcademicLevelSubscription) this.AcademicLevelSubscription = this.AcademicLevelControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'academicLevelId', this.AcademicLevelControl.value);
    });
  }
  changeAcademicLevel(control: FormControl) {
    this.AcademicLevelControl = control;
  }

  loadEducationalStatus() {
    this.getEducationalStatusACFn = (value: any) => this.educationalStatusService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.EducationalStatusSubscription) this.EducationalStatusSubscription = this.EducationalStatusControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'educationalStatusId', this.EducationalStatusControl.value);
    });
  }
  changeEducationalStatus(control: FormControl) {
    this.EducationalStatusControl = control;
  }

  loadServiceParticipation() {
    this.getServiceParticipationACFn = (value: any) => this.serviceParticipationService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.ServiceParticipationSubscription) this.ServiceParticipationSubscription = this.ServiceParticipationControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'serviceParticipationId', this.ServiceParticipationControl.value);
    });
  }
  changeServiceParticipation(control: FormControl) {
    this.ServiceParticipationControl = control;
  }

  // loadTypeOfEducationInvolve() {
  //   this.getTypeOfEducationInvolveACFn = (value: any) => this.typeOfEducationInvolveService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
  //     map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
  //   );
  //   if (!this.TypeOfEducationInvolveSubscription) this.TypeOfEducationInvolveSubscription = this.TypeOfEducationInvolveControl.valueChanges.subscribe(() => {
  //     this.utilService.bindOrUnBindTheId(this.student, 'typeOfEducationInvolveId', this.TypeOfEducationInvolveControl.value);
  //   });
  // }
  // changeTypeOfEducationInvolve(control: FormControl) {
  //   this.TypeOfEducationInvolveControl = control;
  // }

  loadTypeOfOrganization() {
    this.getTypeOfOrganizationACFn = (value: any) => this.typeOfOrganizationService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.TypeOfOrganizationSubscription) this.TypeOfOrganizationSubscription = this.TypeOfOrganizationControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'typeOfOrganizationId', this.TypeOfOrganizationControl.value);
    });
  }
  changeTypeOfOrganization(control: FormControl) {
    this.TypeOfOrganizationControl = control;
  }

  loadKindOfSupport() {
    this.getKindOfSupportACFn = (value: any) => this.kindOfSupportService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.KindOfSupportSubscription) this.KindOfSupportSubscription = this.KindOfSupportControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'kindOfSupportId', this.KindOfSupportControl.value);
    });
  }
  changeKindOfSupport(control: FormControl) {
    this.KindOfSupportControl = control;
  }

  loadCareer() {
    this.getCareerACFn = (value: any) => this.careerService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.CareerSubscription) this.CareerSubscription = this.CareerControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'careerId', this.CareerControl.value);
    });
  }
  changeCareer(control: FormControl) {
    this.CareerControl = control;
  }

  loadFamilyConcernLevel() {
    this.getFamilyConcernLevelACFn = (value: any) => this.familyConcernLevelService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.FamilyConcernLevelSubscription) this.FamilyConcernLevelSubscription = this.FamilyConcernLevelControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'familyConcernLevelId', this.FamilyConcernLevelControl.value);
    });
  }
  changeFamilyConcernLevel(control: FormControl) {
    this.FamilyConcernLevelControl = control;
  }

  loadSuggest() {
    this.getSuggestACFn = (value: any) => this.suggestService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.SuggestSubscription) this.SuggestSubscription = this.SuggestControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'suggestId', this.SuggestControl.value);
    });
  }
  changeSuggest(control: FormControl) {
    this.SuggestControl = control;
  }

  loadStudyMode() {
    this.getStudyModeACFn = (value: any) => this.studyModeService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.StudyModeSubscription) this.StudyModeSubscription = this.StudyModeControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'studyModeId', this.StudyModeControl.value);
    });
  }
  changeStudyMode(control: FormControl) {
    this.StudyModeControl = control;
  }

  loadModesOfEducation() {
    this.getModesOfEducationACFn = (value: any) => this.modesOfEducationService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.ModesOfEducationSubscription) this.ModesOfEducationSubscription = this.ModesOfEducationControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'modesOfEducationId', this.ModesOfEducationControl.value);
    });
  }
  changeModesOfEducation(control: FormControl) {
    this.ModesOfEducationControl = control;
  }

  loadTutorEducationLevels() {
    this.getTutorEducationLevelsACFn = (value: any) => this.EducationLevelsService.getEducationLevelSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.TutorEducationLevelsSubscription) this.TutorEducationLevelsSubscription = this.TutorEducationLevelsControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'tutorEducationLevelId', this.TutorEducationLevelsControl.value);
    });
  }
  changeTutorEducationLevels(control: FormControl) {
    this.TutorEducationLevelsControl = control;
  }

  loadTutorLivingCondition() {
    this.getTutorLivingConditionACFn = (value: any) => this.livingConditionService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.TutorLivingConditionSubscription) this.TutorLivingConditionSubscription = this.TutorLivingConditionControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'tutorLivingConditionId', this.TutorLivingConditionControl.value);
    });
  }
  changeTutorLivingCondition(control: FormControl) {
    this.TutorLivingConditionControl = control;
  }
  loadMaritalStatus() {
    this.getMaritalStatusACFn = (value: any) => this.maritalStatusService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.MaritalStatusSubscription) this.MaritalStatusSubscription = this.MaritalStatusControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'maritalStatusId', this.MaritalStatusControl.value);
    });
  }
  changeMaritalStatus(control: FormControl) {
    this.MaritalStatusControl = control;
  }

  loadEmploymentStatus() {
    this.getEmploymentStatusACFn = (value: any) => this.employmentStatusService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.EmploymentStatusSubscription) this.EmploymentStatusSubscription = this.EmploymentStatusControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'employmentStatusId', this.EmploymentStatusControl.value);
    });
  }
  changeEmploymentStatus(control: FormControl) {
    this.EmploymentStatusControl = control;
  }

  loadLevelOfDevelopment() {
    this.getLevelOfDevelopmentACFn = (value: any) => this.levelOfDevelopmentService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.LevelOfDevelopmentSubscription) this.LevelOfDevelopmentSubscription = this.LevelOfDevelopmentControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'levelOfDevelopmentId', this.LevelOfDevelopmentControl.value);
    });
  }
  changeLevelOfDevelopment(control: FormControl) {
    this.LevelOfDevelopmentControl = control;
  }

  loadchuongTrinhHoc() {
    this.getChuongTrinhHocACFn = (value: any) => this.chuongTrinhHocSearvice.getNoiSinhSelectPaging({ searchTerm: value, DistrictId: this.valueIfHas(this.DistrictControl), PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.chuongTrinhHocSubscription) this.chuongTrinhHocSubscription = this.chuongTrinhHocControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'studyProgramsId', this.chuongTrinhHocControl.value);
    });
  }
  changechuongTrinhHoc(control: FormControl) {
    this.chuongTrinhHocControl = control;
  }
  loadnoiSinh() {
    this.getNoiSinhACFn = (value: any) => this.noiSinhSearvice.getNoiSinhSelectPaging({ searchTerm: value, DistrictId: this.valueIfHas(this.DistrictControl), PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.noiSinhSubscription) this.noiSinhSubscription = this.noiSinhControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'placeOfBirthId', this.noiSinhControl.value);
    });
  }
  changeNoiSinh(control: FormControl) {
    this.noiSinhControl = control;
  }
  loadThoiDiemKT() {
    this.getThoiDiemKTACFn = (value: any) => this.thoiDiemKhuyetTatSearvice.getNoiSinhSelectPaging({ searchTerm: value, DistrictId: this.valueIfHas(this.DistrictControl), PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.thoiDiemKTSubscription) this.thoiDiemKTSubscription = this.thoiDiemKTControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'disabilityMomentId', this.thoiDiemKTControl.value);
    });
  }
  changeThoiDiemKT(control: FormControl) {
    this.thoiDiemKTControl = control;
  }

  loadTutorCareers() {
    this.getTutorCareersACFn = (value: any) => this.tutorCareerService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name,isNote: x.isNote })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.TutorCareersSubscription) this.TutorCareersSubscription = this.TutorCareersControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'tutorCareerId', this.TutorCareersControl.value);
    });
  }
  changeTutorCareers(control: FormControl) {
    this.TutorCareersControl = control;
    if(this.TutorCareersControl){
      this.isNote = this.TutorCareersControl.value.isNote;
    }
  }

   ////////////////////////////////////////////////////// Địa chỉ nơi ở của người giám hộ /////////////////////////////////////////////////////////////////
   loadTutorProvince() {
    this.getTutorProvinceACFn = (value: any) => this.provinceService.getProvinceSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.provinceName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.TutorProvinceSubscription) this.TutorProvinceSubscription = this.TutorProvinceControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'tutorProvinceId', this.TutorProvinceControl.value);
    });
  }
  changeTutorProvince(control: FormControl) {
    this.TutorProvinceControl = control;
    this.loadTutorDistrict();
    this.TutorDistrictControl.setValue(null);
    this.TutorWardControl.setValue(null);
  }

  loadTutorDistrict() {
    this.getTutorDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
      searchTerm: value, ProvinceId: this.valueIfHas(this.TutorProvinceControl), PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.TutorDistrictSubscription) this.TutorDistrictSubscription = this.TutorDistrictControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'tutorDistrictId', this.TutorDistrictControl.value);
    });
  }
  changeTutorDistrict(control: FormControl) {
    this.TutorDistrictControl = control;
    this.loadTutorWard();
    this.TutorWardControl.setValue(null);
  }

  loadTutorWard() {
    this.getTutorWardACFn = (value: any) => this.wardService.getWardSelectPaging({
      searchTerm: value, DistrictId: this.valueIfHas(this.TutorDistrictControl), PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.wardName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.TutorWardSubscription) this.TutorWardSubscription = this.TutorWardControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'tutorWardId', this.TutorWardControl.value);
    });
  }
  changeTutorWard(control: FormControl) {
    this.TutorWardControl = control;
  }


  ////////////////////////////////////////////////////////////////////////////////////End//////////////////////////////////////////////////////////////////////
  search() {
    if (this.commonFilter.IdentificationCode != null) {
      this.msg.error('Không có dữ liệu');

    } else {
      this.msg.error('Không có dữ liệu');
    }
  }
  private getBase64(img: File, callback: (img: string) => void): void {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result!.toString()));
    reader.readAsDataURL(img);
  }
  beforeUpload = (file: NzUploadFile, _fileList: NzUploadFile[]) => {
    return new Observable((observer: Observer<boolean>) => {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.msg.error('You can only upload JPG file!');
        observer.complete();
        return;
      }
      const isLt2M = file.size! / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.msg.error('Image must smaller than 2MB!');
        observer.complete();
        return;
      }
      observer.next(isJpgOrPng && isLt2M);
      observer.complete();
    });
  };

  handleChange(info: { file: NzUploadFile }): void {
    switch (info.file.status) {
      case 'uploading':
        this.loading = true;
        break;
      case 'done':
        // Get this url from response in real world.
        this.getBase64(info.file!.originFileObj!, (img: string) => {
          this.loading = false;
          this.avatarUrl = img;
        });
        break;
      case 'error':
        this.msg.error('Network error');
        this.loading = false;
        break;
    }
  }

  onChangeTutorCertification(event) {
    this.student.tutorCertificated = event;
    if (this.student.tutorCertificated) {
      this.student.tutorUnfostered = true;
    }
  }
  onChangeTutorCertificate(event) {
    this.student.tutorLicensed = event;
    if (this.student.tutorLicensed) {
      this.student.tutorUnfostered = true;
    }
  }
  /////////////
  loadDisTypeOfDisabilitys() {
    // tslint:disable-next-line: max-line-length
    this.getDisTypeOfDisabilitysACFn = (value: any) => this.typeOfDisabilityservice.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      // tslint:disable-next-line: max-line-length
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.typeOfDisabilityName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    // tslint:disable-next-line: max-line-length
    if (!this.disTypeOfDisabilitysSubscription) {
      this.disTypeOfDisabilitysSubscription = this.disTypeOfDisabilitysControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.student, 'typeOfDisabilityId', this.disTypeOfDisabilitysControl.value);
      });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDisTypeOfDisabilitysACFn(control: FormControl) {
    this.disTypeOfDisabilitysControl = control;
  }
  loadLevel() {
    // tslint:disable-next-line: max-line-length
    this.getLevelACFn = (value: any) =>
      this.levelService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
        // tslint:disable-next-line: max-line-length
        map((resp) =>
          resp.results.length > 0
            ? resp.results.map((x) => ({ id: x.id, text: x.levelName }))
            : [{ id: null, text: 'Không có dữ liệu' }]
        )
      );
    // tslint:disable-next-line: max-line-length
    if (!this.LevelSubscription) {
      this.LevelSubscription = this.LevelControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.student, 'levelId', this.LevelControl.value);
      });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeLevelACFn(control: FormControl) {
    this.LevelControl = control;
  }
  listNeedOfDisabilities: any = [];
  loadCaDisEducationalStatuses() {
    this.educationalStatusService
      .getSelectPaging({ PageIndex: 1, PageSize: 100 })
      .subscribe(res => {
        res.results.sort(function (a, b) { return a.displayOrder - b.displayOrder });
        this.listNeedOfDisabilities = res.results.map(x => ({ value: x.id, label: x.name, checked: false, isRequiredNote: x.isRequiredNote }));
      });
  }
  //tình trạng can thiệp
  listStudentInterventionStatus: any = [];
  loadStudentInterventionStatus() {
    this.studentInterventionStatusSearvice
      .getSelectPaging({ PageIndex: 1, PageSize: 100 })
      .subscribe(res => {
        res.results.sort(function (a, b) { return a.displayOrder - b.displayOrder });
        this.listStudentInterventionStatus = res.results.map(x => ({ value: x.id, label: x.name, checked: false, isRequiredNote: x.isRequiredNote }));
      });
  }
  //Lĩnh vực
  listlevelOfDevelopmentTypes: any = [];
  loadlevelOfDevelopmentTypes() {
    // this.levelOfDevelopmentTypesService
    //   .getSelectPaging({ PageIndex: 1, PageSize: 100 })
    //   .subscribe(res => {
    //     res.results.sort(function (a, b) { return a.displayOrder - b.displayOrder });
    //     this.listlevelOfDevelopmentTypes = res.results.map(x => ({ id: x.id, name: x.name, levelOfDevelopmentId: 0, levelOfDevelopmentTypeId: x.id }));
    //   });
  }
  //Mức độ phát triển
  listlevelOfDevelopment: any = [];
  loadlevelOfDevelopment() {
    this.levelOfDevelopmentService
      .getSelectPaging({ PageIndex: 1, PageSize: 100 })
      .subscribe(res => {
        res.results.sort(function (a, b) { return a.displayOrder - b.displayOrder });
        this.listlevelOfDevelopment = res.results.map(x => ({ id: x.id, name: x.name }));
      });
  }
  //Cấp học
  loadSchoolLevel() {
    this.getSchoolLevelACFn = (value: any) => this.publicService.getPublicSchoolLevels({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.schoolLevelName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.SchoolLevelSubscription) this.SchoolLevelSubscription = this.SchoolLevelControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'schoolLevelId', this.SchoolLevelControl.value);
    });
  }
  changeSchoolLevel(control: FormControl) {
    this.SchoolLevelControl = control;
  }

  listStatuses = [];
  educationalStatusIdChange(event) {
    this.student.educationalStatusId = event;
    this.student.studyingClassYear = '';
    this.student.droppedOutClassYear = '';
    this.student.notYetLearnedNote = '';
    this.student.droppedOutNote = '';
    this.disStudyModeControl.setValue(null);
    this.EducationLevelControl.setValue(null);
  }
  loadDisStudyMode() {
    // tslint:disable-next-line: max-line-length
    this.getDisStudyModeACFn = (value: any) =>
      this.publicService
        .getPublicStudyModes({ searchTerm: value, PageIndex: 1, PageSize: 100 })
        .pipe(
          // tslint:disable-next-line: max-line-length
          map((resp) =>
            resp.results.length > 0
              ? resp.results.map((x) => ({ id: x.id, text: x.name }))
              : [{ id: null, text: 'Không có dữ liệu' }]
          )
        );
    // tslint:disable-next-line: max-line-length
    if (!this.disStudyModeSubscription) {
      this.disStudyModeSubscription = this.disStudyModeControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(
          this.student,
          'studyModeId',
          this.disStudyModeControl.value
        );
      });
    }
  }
  getStatuses() {
    this.publicService.getPublicStatuses({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      res.results.sort(function (a, b) { return a.displayOrder - b.displayOrder });
      this.listStatuses = res.results;
    });
  }
  loadEducationLevel() {
    this.getEducationLevelACFn = (value: any) => this.publicService.getPublicEducationLevels({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.EducationLevelSubscription) this.EducationLevelSubscription = this.EducationLevelControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'educationLevelId', this.EducationLevelControl.value);
    });
  }
  changeEducationLevel(control: FormControl) {
    this.EducationLevelControl = control;
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDisStudyMode(control: FormControl) {
    this.disStudyModeControl = control;
  }
  getDisStudyModeACFn: (value: any) => Observable<any>;
  disStudyModeSubscription: any;
  disStudyModeControl = new FormControl();

  getEducationLevelACFn: (value: any) => Observable<any>;
  EducationLevelSubscription: any;
  EducationLevelControl = new FormControl();

  getSchoolLevelACFn: (value: any) => Observable<any>;
  SchoolLevelSubscription: any;
  SchoolLevelControl = new FormControl();
  //
  disDisabilityCertificateTypeChange(event) {
    this.student.interventioned = event;
    if (!event) {
      this.listStudentInterventionStatus.forEach(item => {
        item.checked = false;
      });
    }
  }
  //C. nhu cầu hỗ trợ
  listEducationalSupports = [];
  listTutorEducationalSupports = [];
  getEducationalSupports() {
    this.needForEducationalSpService.getSelectPaging({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      res.results.sort(function (a, b) { return a.displayOrder - b.displayOrder });
      this.listEducationalSupports = res.results.map(x => ({ value: x.id, name: x.name, checked: false, isApprentice: x.isApprentice, isEarlyIntervention: x.isEarlyIntervention, isEducationFacilitiesEquipment: x.isEducationFacilitiesEquipment, isRequiredNote: x.isRequiredNote }));
      this.listTutorEducationalSupports = res.results.map(x => ({ value: x.id, name: x.name, checked: false, isApprentice: x.isApprentice, isEarlyIntervention: x.isEarlyIntervention, isEducationFacilitiesEquipment: x.isEducationFacilitiesEquipment, isRequiredNote: x.isRequiredNote }));
    });
  }
  changeOneCheckES(event, index) {
    this.listEducationalSupports[index].checked = event;
    if (this.listEducationalSupports[index].name === "Thiết bị, phương tiện hỗ trợ" && !this.listEducationalSupports[index].checked) {
      this.student.listStudentFacilitiesAndEquipmentNkt = [];
    }
  }
  //phương tiện thiết bị
  listNeedForEducationalSp = [];
  listOfSelectedNeedForEducationalSp = [];
  listPublicCommunityCoordinations = [];
  listLocalGovernmentCoordinations = [];
  loadNeedForEducationalSp() {
    this.ptHtNktVanDongService.getSelectPaging({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      this.listNeedForEducationalSp = res.results.map(x => ({ id: x.id, name: x.name, isNote: x.isNote }));
    });
  }
  //D
  listDisabilityPolicy = [];
  listInformationSources = [];
  getDisabilityPolicy() {
    this.publicService.getPublicDisabilityPolicy({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      res.results.sort(function (a, b) { return a.displayOrder - b.displayOrder });
      this.listDisabilityPolicy = res.results.map(x => ({ value: x.id, name: x.name, checked: false, isRequiredNote: x.isRequiredNote }));
    });
  }
  understandDisabilityPolicyChange(event) {
    this.student.understandDisabilityPolicy = event;
    if (this.student.understandDisabilityPolicy === false) {
      this.listDisabilityPolicy.forEach(element => {
        element.checked = false;
      });
    }
    this.student.disabilityPolicyNote = '';
  }
  disabilityPolicyCheckedChange(event, index) {
    this.listDisabilityPolicy[index].checked = event;
    if (this.listDisabilityPolicy[index].isRequiredNote && !this.listDisabilityPolicy[index].checked) {
      this.student.disabilityPolicyNote = '';
    }
  }
  getInformationSources() {
    this.publicService.getPublicInformationSources({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      res.results.sort(function (a, b) { return a.displayOrder - b.displayOrder });
      this.listInformationSources = res.results.map(x => ({ value: x.id, name: x.name, checked: false, isRequiredNote: x.isRequiredNote }));
    });
  }
  changeOneCheckInformationSources(event, index) {
    this.listInformationSources[index].checked = event;
    if (this.listInformationSources[index].isRequiredNote && !this.listInformationSources[index].checked) {
      this.student.informationSourceNote = '';
    }
  }
  getPublicLocalGovernmentCoordinations() {
    this.publicService.getPublicLocalGovernmentCoordinations({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      res.results.sort(function (a, b) { return a.displayOrder - b.displayOrder });
      this.listLocalGovernmentCoordinations = res.results.map(x => ({ value: x.id, name: x.name, checked: false }));
    });
  }
  getPublicCommunityCoordinations() {
    this.publicService.getPublicCommunityCoordinations({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      res.results.sort(function (a, b) { return a.displayOrder - b.displayOrder });
      this.listPublicCommunityCoordinations = res.results.map(x => ({ value: x.id, name: x.name, checked: false }));
    });
  }
  loadtutorFolk() {
    this.gettutorFolkACFn = (value: any) => this.folkService.getFolkSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.folkName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.tutorFolkSubscription) this.tutorFolkSubscription = this.tutorFolkControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'tutorFolkId', this.tutorFolkControl.value);
    });
  }
  changetutorFolk(control: FormControl) {
    this.tutorFolkControl = control;
  }
  tutorUnfosteredChange(event) {
    this.student.tutorUnfostered = event;
  }
  updatelist() {
    this.student.listStudentInterventionStatus = [];
    this.student.listStudentEducationSupport = [];
    this.student.listStudentLevelOfDevelopment = [];
    this.student.listStudentDisabilityPolicy = [];
    this.student.listStudentInformationSource = [];
    this.listStudentInterventionStatus.forEach(element => {
      if (element.checked) {
        this.student.listStudentInterventionStatus.push(element.value);
      }
    });
    this.listlevelOfDevelopmentTypes.forEach(element => {
      if (element.levelOfDevelopmentId !== 0) {
        this.student.listStudentLevelOfDevelopment.push({ id: element.idDev, studentId: this.dataTransmission.id, levelOfDevelopmentId: element.levelOfDevelopmentId, levelOfDevelopmentTypeId: element.levelOfDevelopmentTypeId });
      }
    });
    this.listEducationalSupports.forEach(element => {
      if (element.checked) {
        this.student.listStudentEducationSupport.push(element.value);
      }
    });
    this.listDisabilityPolicy.forEach(element => {
      if (element.checked) {
        this.student.listStudentDisabilityPolicy.push(element.value);
      }
    });
    this.listInformationSources.forEach(element => {
      if (element.checked) {
        this.student.listStudentInformationSource.push(element.value);
      }
    });
  }
  loadRelationship() {
    this.getRelationshipACFn = (value: any) => this.relationshipService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.RelationshipSubscription) this.RelationshipSubscription = this.RelationshipControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.student, 'tutorRelationshipId', this.RelationshipControl.value);
    });
  }
  changeRelationship(control: FormControl) {
    this.RelationshipControl = control;
  }
  nameStatusEducation = null;
  hasStatusEducation = false;
  setStatusEducation() {
    let maxYear = 0;
    let index = 0;
    let statusEducation;
    if (this.listQTHT.length > 0) {
      this.hasStatusEducation = true;
      this.listQTHT.forEach((element, i) => {
        let year = parseInt(element.courseName);
        if (year >= maxYear) {
          maxYear = year;
          index = i;
        }
      });
      statusEducation = this.listQTHT[index];
      this.student.educationalStatusId = statusEducation.educationalStatusId;
      this.student.studyingClassYear = statusEducation.studyingClassYear;
      this.student.schoolLevelId = statusEducation.schoolLevelId;
      this.disSchoolLevelsService.getSelectPagingSchoolLevelsById(statusEducation.schoolLevelId).subscribe(res => {
        this.SchoolLevelControl.setValue({ id: res.id, text: res.schoolLevelName });
      });
      this.nameStatusEducation = statusEducation.educationalStatusName;
    } else {
      this.hasStatusEducation = false;
      this.student.educationalStatusId = null;
      this.student.studyingClassYear = null;
      this.student.schoolLevelId = null;
      this.SchoolLevelControl.setValue(null);
      this.nameStatusEducation = null;
    }
  }
  imageError: string;
  isImageSaved: boolean;
  cardImageBase64: string;
  fileChangeEvent(fileInput: any) {
    this.imageError = null;
    if (fileInput.target.files && fileInput.target.files[0]) {
      // Size Filter Bytes
      const allowed_types = ['image/png', 'image/jpeg'];
      if (!_.includes(allowed_types, fileInput.target.files[0].type)) {
        this.imageError = 'Chỉ chấp nhận ảnh ( JPG | PNG )';
        return false;
      }
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const image = new Image();
        image.src = e.target.result;
        image.onload = rs => {
          // Resize the image using canvas
          var canvas = document.createElement('canvas');
          canvas.width = 200;
          canvas.height = 200;
          canvas.getContext('2d').drawImage(image, 0, 0, 200, 200);
          //Getting base64 string;
          var dataUrl = canvas.toDataURL('image/jpeg');
          //const imgBase64Path = e.target.result;
          this.cardImageBase64 = dataUrl;
          this.isImageSaved = true;
        };
      };
      reader.readAsDataURL(fileInput.target.files[0]);
    }
  }
  removeImage() {
    this.cardImageBase64 = null;
    this.isImageSaved = false;
  }
}
class LevelOdedto {
  levelOfDevelopmentId: number;
  levelOfDevelopmentTypeId: number;
}
